"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusDisplay = exports.StatusBadge = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactStatusColorIndicator = _interopRequireDefault(require("@adsk/alloy-react-status-color-indicator"));
var _statusFieldHelpers = require("../../utils/data/statusFieldHelpers");
var _StatusText = require("../../utils/components/StatusText");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getIndicatorStyle = (status, indicatorStyle) => ({
  //Have to use style to bypass alloy styles
  height: 16,
  width: 4,
  backgroundColor: (0, _statusFieldHelpers.getStatusColor)(status),
  marginRight: 8,
  ...indicatorStyle
});
const StatusBadge = _ref => {
  let {
    status,
    indicatorStyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_alloyReactStatusColorIndicator.default, {
    style: getIndicatorStyle(status, indicatorStyle)
  });
};
exports.StatusBadge = StatusBadge;
const StatusDisplay = _ref2 => {
  let {
    status,
    indicatorStyle
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    },
    title: status
  }, /*#__PURE__*/_react.default.createElement(StatusBadge, {
    status: status,
    indicatorStyle: indicatorStyle
  }), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_StatusText.StatusText, {
    status: status
  })));
};
exports.StatusDisplay = StatusDisplay;
//# sourceMappingURL=StatusDisplay.js.map